import * as React from 'react'
// import * as classnames from 'classnames'

import * as styles from './landing.css'

import { injectStores, StoreComponent } from '../../store'
import { observer } from 'mobx-react'
import { MenuButton, StartButton } from '../common/elements/buttons'
import { Menu } from '../common/header/menu'
import { Portal } from 'react-portal'
import { bind } from 'bind-decorator'
import { Raster } from '../common/elements/raster'

const lesenButton = require('../common/icons/read-chapter.svg')
const lesenButtonMobile = require('../common/icons/mobile-read-chapter.svg')

@injectStores
@observer
export class Landing extends StoreComponent {

  constructor (props: any, context: any) {
    super(props, context)
    if (this.store.storyDocContent.chapters.length === 0) {
      this.store.storyDocContent.fetchChapters()
    }
  }

  componentDidUpdate () {
    // this.store.storyDocContent.fetchTitlePage()
  }

  @bind
  handleChange () {
    if (this.store.storeCommon.menu.language === 'en') {
      this.store.storeCommon.menu.language = 'de'
      localStorage.setItem('language', 'de')

    } else {
      this.store.storeCommon.menu.language = 'en'
      localStorage.setItem('language', 'en')
    }
    this.store.storyDocContent.fetchTitlePage()
    this.store.storyDocContent.fetchChapters()
  }

  render () {
    let menu: JSX.Element | null = null
    menu = <Portal> <Menu /> </Portal>

    let overlayBlack: JSX.Element | null = null
    overlayBlack = <div className={ styles.overlayBlack }></div>

    let chooseText: string
    if (this.store.storeCommon.menu.language === 'en') {
      chooseText = 'Choose your language'
    } else {
      chooseText = 'Wählen Sie ihre Sprache'
    }

    let languageBox: JSX.Element | null = null
    languageBox = <div className={styles.languageBox}>
                    <div className={styles.choiceText}>{chooseText}</div>
                    <label className={styles.choiceSliderContainer}>
                      <input type='checkbox' value={this.store.storeCommon.menu.language} onChange={this.handleChange} checked={this.store.storeCommon.menu.language === 'en'}/>
                      <div className={ styles.choiceSlider }/>
                      <div className={this.store.storeCommon.menu.language === 'de' ? styles.activeLanguage : styles.choiceLanguage}>Deutsch</div>
                      <div className={this.store.storeCommon.menu.language === 'en' ? styles.activeLanguage : styles.choiceLanguage}>English</div>
                    </label>
    {/* <TickButton className={styles.choiceTick} to={`/story/${'W6tPMRMAALCx8zri'}`}/> */}
                  </div >

    let burgerText: JSX.Element | null = null
    if (this.store.breakpoints.phone) burgerText = <span className={styles.burgerText}>Konrad Adenauer</span>

    let captionText: string = ''
    if (this.store.storyDocContent.titlePage) {
      captionText = this.store.storyDocContent.titlePage.subtitle.replace(/–/g, '<br>-')
    }

    return (
      <div className={ styles.landing }
      style={{ backgroundImage: this.store.storyDocContent.titlePage ? `url(${ this.store.storyDocContent.titlePage.urlBgImage })` : 'none', height: this.store.storeCommon.window.height }}
      >
       <Raster />
       {overlayBlack}
        <div className={styles.textBox}>
          <div className={styles.title}>{this.store.storyDocContent.titlePage && this.store.storyDocContent.titlePage.title}</div>
          <div className={styles.caption} dangerouslySetInnerHTML={{ __html: captionText }}/>
        </div>
        { languageBox }
        <StartButton className={ styles.startButton } to={`/story/${'konrad-adenauer'}`}>
          <img src={ this.store.breakpoints.desktop ? lesenButton : lesenButtonMobile } />
        </StartButton>
        <div className={ styles.burger }>
          {burgerText}
          <MenuButton className={ styles.menuButton } onClick={ () => this.store.storeCommon.menu.open = !this.store.storeCommon.menu.open }/>
        </div>
        {menu}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/landing/landing.tsx